// accordionみたいな
jQuery(function($) {
  var $target = $('.js-qanda');
  // var $spAccordion = $('.js-sp-accordion');
  // var spAccordionFlag = false;

  if ($target.length) {
    // var $trigger = $target.find('.p-qanda__head');
    // var $item = $trigger.next();
    // $accordionTrigger.on("click", function(){
    $(document).on('click', '.p-qanda__head', function(){
      toggleAccordion($(this));
    });
  }

  // ▼共通アコーディオン関数
  function toggleAccordion($elm) {
    $accordionTarget = $elm.next();
    if ($accordionTarget.is(':hidden')) {
      $elm.parent().addClass('is-active');
      $accordionTarget.slideDown(300);
    } else {
      $elm.parent().removeClass('is-active');
      $accordionTarget.slideUp(300);
    }
    // console.log('toggleAccordion');
  }

});
